import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";

import {
  getActiveAccount,
  handleRedirectPromise,
  initializeMsal,
  loginRedirect,
  logoutRedirect,
} from "./msalInstance";

const AuthContext = createContext({
  isInitialized: false,
  isAuthenticated: false,
  account: null,
  error: null,
  loginRedirect: () => Promise.resolve(),
  logoutRedirect: () => Promise.resolve(),
});

export const AuthProvider = ({ children }) => {
  const [state, setState] = useState({
    isInitialized: false,
    isAuthenticated: false,
    account: null,
    error: null,
  });

  useEffect(() => {
    let isMounted = true;

    const initialize = async () => {
      try {
        await initializeMsal();
        await handleRedirectPromise();
        const account = getActiveAccount();

        if (!isMounted) return;

        // eslint-disable-next-line no-console
        console.log("[auth] init state", {
          hasAccount: Boolean(account),
          account,
        });

        setState({
          isInitialized: true,
          isAuthenticated: Boolean(account),
          account,
          error: null,
        });
      } catch (error) {
        if (!isMounted) return;

        setState({
          isInitialized: true,
          isAuthenticated: false,
          account: null,
          error,
        });
      }
    };

    initialize();

    return () => {
      isMounted = false;
    };
  }, []);

  const value = useMemo(
    () => ({
      ...state,
      loginRedirect,
      logoutRedirect,
    }),
    [state],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

AuthProvider.propTypes = {
  children: PropTypes.node,
};

export const useAuth = () => useContext(AuthContext);

export default AuthProvider;
